import React, { useState } from 'react';
import { View, TouchableOpacity, Text, StyleSheet, Dimensions } from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import { MailOutOfStockReport, removeItem } from '../../helpers/suggestedMenuFunctions';
import { fontFamily } from '../../helpers/fontFamily';
import i18n from 'i18n-js';
import { useDispatch } from 'react-redux';
import OutOfStockPrompt from '../scanToCart/OutOfStockConfirmPrompt';

const StockMenu = ({ getWidth, setShowMenu, props, setIsRemoved,returnLaterPrompt = false }) => {
  const dispatch = useDispatch();
  const windowWidth = Dimensions.get('window').width;
  const [showReturnLaterPrompt, setShowReturnLaterPrompt] = useState(false);

  const handleOutOfStockReport = () => {
    if (returnLaterPrompt) {
      setShowReturnLaterPrompt(true);
    } else {
      setShowMenu(false);
      MailOutOfStockReport(props);
    }
  };

  const handleReturnLaterConfirm = (returnLater) => {
    // Process the out of stock report with the user's choice
    MailOutOfStockReport(props, returnLater);
    // Close both the prompt and the menu
    setShowReturnLaterPrompt(false);
    setShowMenu(false);
  };

  const handleRemoveItem = () => {
    setShowMenu(false);
    setIsRemoved(true);
    removeItem(props, dispatch);
  };

  return (
    <>
      {/* Original StockMenu */}
      <View style={[styles.buttonContainer, { width: getWidth(), height: getWidth() / 2, zIndex: 9999, padding: 15 }]}>
        <View style={styles.shade} />
        <TouchableOpacity
          style={styles.button}
          testID="OutOfStockReport"
          onPress={handleOutOfStockReport}>
          <Text style={styles.buttonText}>{i18n.t('scanpackItem.outOfStockLabel')}</Text>
          <i
            className="icon-comment"
            style={{ color: '#fff', fontSize: 30 }}
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          testID="RemoveItem"
          onPress={handleRemoveItem}>
          <Text style={styles.buttonText}>Remove</Text>
          <FontAwesome name="bomb" size={30} color={'#fff'} />
        </TouchableOpacity>
        <TouchableOpacity
          testID="CloseButton"
          style={[styles.button, { top: windowWidth < 1400 ? '55%' : '85%', justifyContent: 'center' }]}
          onPress={() => setShowMenu(false)}>
          <Text style={styles.buttonText}>Close</Text>
        </TouchableOpacity>
      </View>

      {/* Return Later Prompt - appears above StockMenu when triggered */}
      {returnLaterPrompt && 
        <OutOfStockPrompt
          showPrompt={showReturnLaterPrompt}
          setShowPrompt={setShowReturnLaterPrompt}
          props={props}
          onConfirm={handleReturnLaterConfirm}
        />
      }
    </>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    padding: 10,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    zIndex: 30,
  },
  button: {
    backgroundColor: '#3d4851',
    padding: 10,
    borderRadius: 5,
    margin: 5,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  buttonText: {
    color: '#fff',
    fontSize: 20,
    fontFamily: fontFamily.font700,
  },
  shade: {
    borderRadius: 21,
    position: 'absolute',
    top: 10,
    bottom: '-106%',
    left: -4,
    right: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
});

export default StockMenu;
